import './Feedback.scss';

import { useEffect, useRef, useState } from 'react';

import { Dropdown, message, Modal } from 'antd';
import IconButton from './IconButton';
import { SVGPureIcon } from '@/ui';
import { observer } from 'mobx-react-lite';
import globalStore from '@/store/global';
import chatStoreManager from '@/store/chat/manager';
import navbar from '@/store/navbar';
import userStore from '@/store/user';
import Urm from '@public/urm';
import appLogger from '@public/log/monitor';
import { HelperCore } from "@/common/helper";
import { getModelCategory, getModelName } from '@shared/store/chat';
import useIsAiso, { useIsAgentChat, useIsModelChat } from '@/hooks/useIsAiso';

const Button = ({ className, icon, onClick }) => (
  <IconButton
    className={`!p-0 !hover:bg-gray-nav-hover ${globalStore.isDark ? 'hover:bg-gray-nav-hover' : ''}`}
    iconClassName={[globalStore.isDark ? 'text-primary' : 'text-[#000000]', className].join(' ').trim()}
    icon={icon}
    size={28}
    onClick={onClick}
  />
);

function Feedback(props) {
  const { msg_id, chatId, prompt, messageItem, showType } = props;
  const feedbackReasons = globalStore.cloudConfig.feedbackReasons;
  const [open, setOpen] = useState(false);
  const [negativeOpen, setNegativeOpen] = useState(false);
  const [inputText, setInputText] = useState('');
  const [selectDataList, setSelectDataList] = useState([]);
  const successType = useRef('');
  const activeType = useRef('');
  let chatStore = chatStoreManager.current
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const isAiso = useIsAiso();
  const isAgentChat = useIsAgentChat();
  const isModelChat = useIsModelChat();
  
  const handleSubmit = () => {
    if (!selectDataList.length && !inputText) {
      return message.error('请选择或填写反馈的内容!');
    }

    // 需求 https://geelib.qihoo.net/geelib/project/matterType/10942?subId=4665&matterId=611093&typeId=10942
    let type = '';
    if (isAiso) {
      type = 'super_search';
    }else if (isAgentChat) {
      type = 'agent';
    }else if (isModelChat) {
      type = 'model';
    }
    
    let arr = [...selectDataList];
    if (inputText.trim()) {
      arr.push(inputText);
    }
    const browserInfo = HelperCore.getBrowserNameAndVersion();
    let browser_ver = `${browserInfo.name} ${browserInfo.version}`;
    const OsInfo = HelperCore.getOsInfo();
    let os_ver = `${OsInfo.name} ${OsInfo.version}`;
    let skill = (typeof messageItem.page === 'string' && messageItem.page) || (Array.isArray(messageItem.page) && messageItem.page.length) ? '总结网页' : getModelCategory(messageItem)
    
    // 模型名称：先取消息体中的(stat_model)，没有的通过role_id匹配模型列表中的(解释和总结)
    let model = getModelName(messageItem)?.title || navbar.chatModels[messageItem.role_id]?.title || ''
    model = model || chatStore.mcpStore.agentInfo.title || '';
    let url = `${location.origin}/chat/${messageItem.conversation_id || chatStoreManager.current.chatId}`
    url = location.href;

    const urmData = {
      // feedback_reason: arr.join(',').replace(/\,/g, '|'),
      like_type: activeType.current,
      tag: 'single',
      content: [messageItem.prompt || '', arr.join(',').replace(/\,/g, '|')].join('#'),
      message_id: msg_id || '',
      // mes_id : this.messageId,
      coversation_id: messageItem.conversation_id || chatStoreManager.current.chatId,
      qid: String(userStore.uid),
      result: messageItem.result || '',
      url,
      model,
      browser_ver: browser_ver,
      skill,
      os_ver: os_ver,
      mid: HelperCore.getMid(),
      type,
    };
    try{
      if(messageItem.page?.length){
        urmData.summary_web_url = messageItem.page[0].url;
      }
    } catch(e){};
    console.log('Feedback submit', urmData);

    Urm.report(urmData)
      .then(res => {
        if (res.code == 0) {
          message.success('反馈成功!');
          activeType.current == 'like'
            ? setOpen(false)
            : setNegativeOpen(false);
          successType.current = activeType.current;
          activeType.current = '';
          if (showType === 'dialog') {
            setIsDialogOpen(false);
          }
        }
      })
      .catch(err => {
        console.log(err);
        message.error('反馈失败!');
      });
  };

  const reset = () => {
    setSelectDataList([]);
    setInputText('');
  };

  useEffect(() => {
    // 请求云控数据
    return () => {
      setInputText('');
    };
  }, []);

  const dropList = type => {
    return (
      <div
        className={["w-[292px] p-[16px] rounded-[16px]", showType === 'dialog' ? 'w-[400px]' : '', globalStore.isDark ? 'bg-[#31313A]' : 'bg-white']}
        style={{ boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.1)' }}
      >
        <div className="w-full font-bold text-[16px] left-[22px] mb-[12px]">
          反馈
        </div>
        <div className="w-full mb-[16px] flex flex-wrap gap-[8px]">
          {feedbackReasons
            .filter(x => x.type === type)
            .map((x, index) => {
              const checked = selectDataList.includes(x.content);
              return (
                <div
                  key={index}
                  className={`h-[32px] cursor-pointer flex items-center text-[13px] text-black`}
                  onClick={() => {
                    if (selectDataList.includes(x.content)) {
                      setSelectDataList([
                        ...selectDataList.filter(_ => _ != x.content),
                      ]);
                    } else {
                      setSelectDataList([...selectDataList, x.content]);
                    }
                  }}
                >
                  <div
                    className="h-[32px] px-[10px] rounded-[10px] flex justify-center items-center leading-[32px]"
                    style={
                      checked
                        ? {
                            color: '#fff',
                            background: '#000',
                            fontWeight: 'bold',
                            border: '1px solid transparent',
                          }
                        : { 
                          color: globalStore.isDark ? '#fff' : '#000',
                          border: globalStore.isDark ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.1)'
                        }
                    }
                  >
                    {x.content}
                  </div>
                </div>
              );
            })}
        </div>
        <textarea
          className={["w-full h-[88px] mb-[12px] p-[10px] rounded-[10px] resize-none block", globalStore.isDark ? 'bg-[#45454E]' : 'bg-[#F6F7F9]']}
          placeholder="写下更详细的情况"
          value={inputText}
          name=""
          id=""
          maxLength={200}
          onChange={e => {
            setInputText(e.target.value);
          }}
        ></textarea>
        <div className="w-full h-[32px] flex justify-end gap-[12px] text-[13px] text-black font-bold">
          <div
            className={["h-full px-[18px] h-32px leading-32px cursor-pointer rounded-[10px] text-black font-bold text-opacity-50 hover:bg-[#F0F2F5] hover:bg-opacity-100 active:bg-[#E6E6E6] active:bg-opacity-100 bg-[#F7F7F7]", globalStore.isDark ? 'bg-opacity-40' : '']}
            onClick={e => {
              if (showType === 'dialog') {
                setIsDialogOpen(false);
              } else {
                activeType.current == 'like'
                  ? setOpen(false)
                  : setNegativeOpen(false);
                activeType.current = '';
              }
            }}
          >
            取消
          </div>
          <div
            className="h-full px-[18px] h-32px leading-32px cursor-pointer rounded-[10px] text-white font-bold"
            style={{
              background: '#000',
            }}
            onClick={e => {
              handleSubmit();
            }}
          >
            提交
          </div>
        </div>
      </div>
    );
  };

  const menus = [
    {
      key: '1',
      label: (
        <div
          className='flex flex-row justify-left items-center'
          onClick={() => {
            setIsDialogOpen(true)
          }}
        >
          <SVGPureIcon name="jubao" className="size-20px mr-8px" />
          举报
          </div>
      ),
    },
  ]

  return showType === 'dialog' ? (
    <div>
      <Dropdown
        menu={{ items:menus }}
        overlayClassName="dropdown"
      >
        <div className={`w-32px h-32px mr-12px border-1px border-black border-opacity-10 rounded-16px cursor-pointer flex justify-center items-center hover:bg-[rgba(0,0,0,.03)]`}>
          <SVGPureIcon name="more" className="size-16px" />
        </div>
      </Dropdown>
      <Modal title={null} footer={null} closable={false} wrapClassName="share-html" open={isDialogOpen}>
        {dropList('dis_like')}
      </Modal>
    </div>
  ) : (
    <section className="message-urm-feedback flex gap-[12px]">
      <Dropdown
        dropdownRender={() => dropList('like')}
        trigger="click"
        placement="topRight"
        open={open}
        onOpenChange={visible => {
          setOpen(visible);
          !visible && (activeType.current = '');
        }}
      >
        <Button
          key={msg_id + 'thumbs-up'}
          icon="thumbs-up"
          className={`${activeType.current == 'like' || successType.current == 'like' ? 'active' : 'opacity-50'}`}
          onClick={() => {
            activeType.current = 'like';
            reset();
            chatStore.log({
              action: 'click',
              set: 'feedback_like', 
              message_id: msg_id,
            });
          }}
        />
      </Dropdown>
      <Dropdown
        dropdownRender={() => dropList('dis_like')}
        trigger="click"
        placement="topRight"
        open={negativeOpen}
        onOpenChange={visible => {
          setNegativeOpen(visible);
          !visible && (activeType.current = '');
        }}
      >
        <Button
          key={msg_id + 'thumbs-down'}
          icon="thumbs-down"
          className={`${activeType.current == 'dis_like' || successType.current == 'dis_like' ? 'active dis-like' : 'opacity-50'}`}
          onClick={() => {
            activeType.current = 'dis_like';
            reset();
            chatStore.log({
              action: 'click',
              set: 'feedback_dislike', 
              message_id: msg_id,
            });
          }}
        />
      </Dropdown>
    </section>
  );
}

export default observer(Feedback);
